import { placeLineAndScatterTiles } from '../place-tile-lines';
import type { GenerateFillLayoutOptions, TileLayoutResult } from '../tile-layout-types';

import { createFillLayoutContext, finalizeFillLayout } from './fill-layout-context';

/**
 * Straight segments and single-bend L stamps first (~70% of budget), then short scatter strips.
 * Prefer when you want clear wall segments rather than organic growing wall lines.
 */
export function generateSingleRightAnglesAndLinesLayout(options: GenerateFillLayoutOptions): TileLayoutResult {
  const ctx = createFillLayoutContext(options);
  const { lineTileCount, scatterTileCount } = placeLineAndScatterTiles({
    grid: ctx.grid,
    width: ctx.width,
    height: ctx.height,
    budget: ctx.budget,
    gapTiles: ctx.gapTiles,
    minPlacementSizeTiles: ctx.minPlacementSizeTiles,
    maxPlacementSizeTiles: ctx.maxPlacementSizeTiles,
    fillValue: ctx.fillTileValue,
    rand: ctx.rand
  });
  return finalizeFillLayout(ctx, 'singleRightAnglesAndLines', lineTileCount, scatterTileCount);
}
